export default __webpack_public_path__ + "images/alert-icon.svg";